module.exports = __webpack_public_path__ + "img/2.34cc0758.png";